// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Where vars like --palette-fonts-sansSerifStack are used here, they come from
 * ckEditorStlyes.ts and are named in a convention symmetric with the structure
 * of the \`theme\` object.
 */

.ck.ck-poll-form {
	border-radius: 6px;
	border: 0.5px solid #E1E1E1;
	background: var(--palette-panelBackground-default);
	box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.10);
	padding: 12px;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.ck-reset_all .ck-poll-form-row {
	display: flex;
	gap: 12px;
}

.ck-reset_all .ck-poll-form-group {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.ck-reset_all .ck-poll-form-label {
	text-transform: uppercase;
	font-size: 11px;
	font-weight: 700;
	color: var(--palette-grey-600);
	font-family: var(--palette-fonts-sansSerifStack);
}

.ck-reset_all .ck-poll-form-input {
	background: var(--palette-grey-600);
	border-radius: 4px;
	opacity: 0.8;
	background: var(--palette-grey-200);
  min-width: 225px;
  max-width: 490px;
	width: 100%;
	padding: 8px;
	font-size: 13px;
	font-weight: 500;
	color: var(--palette-grey-1000);
	font-family: var(--palette-fonts-sansSerifStack);
}

.ck.ck-reset_all .ck.ck-poll-form .ck-poll-form-input:hover,
.ck.ck-reset_all .ck.ck-poll-form .ck-poll-form-input:focus {
	background: var(--palette-grey-300);
}

.ck.ck.ck.ck.ck.ck-poll-balloon {
	box-shadow: none;
  background: none; 
  border: none;
}

.ck-poll-balloon:before {
	display: none;
}

.ck-poll-balloon:after {
	display: none;
}

.ck-reset_all .ck-poll-form-label-bold {
  margin-bottom: 4px;
  font-weight: bold;
}

.ck-reset_all .ck-poll-color-selector-container {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
}

.ck-reset_all .ck-poll-duration-group {
  margin-left: 20px;
}

.ck-reset_all .ck-poll-duration-input-container {
  display: flex;
  align-items: center;
}

.ck-reset_all .ck-poll-duration-label-unit {
  margin: 0 16px 0 6px;
  font-weight: 500;
  color: var(--palette-grey-1000);
}

.ck-reset_all .ck-poll-duration-label-unit:last-of-type {
  margin-left: 6px;
  margin-right: 0;
}

.ck-reset_all .ck-color-selector-button {
  border: 1px solid #ccc;
  box-sizing: border-box;
  cursor: pointer;
}

.ck-reset_all .ck-color-selector-button.ck-on {
  border: 2px solid lightblue;
}

.ck-reset_all .ck-duration-input {
  width: 50px;
  min-width: 50px;
  padding: 4px 8px;
}

.ck-poll {
  font-family: var(--palette-fonts-sansSerifStack);
  text-align: center;
  background: var(--forum-event-background);
  border-radius: calc(var(--borderRadius-default) * 1px);
  margin: 10px 0;
  padding: 20px;
}
.ck-poll-question {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: var(--forum-event-banner-text);
}
.ck-poll-slider {
  position: relative;
  height: 2px;
  background: var(--forum-event-foreground);
  margin: 40px 40px 0px 40px;
}
.ck-poll-circle {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: black;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid var(--forum-event-foreground);
  opacity: 0.3;
}
.ck-poll-labels {
  display: flex;
  justify-content: space-between;
  color: var(--forum-event-banner-text);
  margin: 10px 40px;
}
.ck-poll-label {
  font-weight: 500;
  color: var(--forum-event-banner-text);
}
`, "",{"version":3,"sources":["webpack://./src/ckeditor5-poll/poll.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;CACC,kBAAkB;CAClB,2BAA2B;CAC3B,kDAAkD;CAClD,+CAA+C;CAC/C,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,OAAO;CACP,aAAa;CACb,sBAAsB;CACtB,QAAQ;AACT;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,8BAA8B;CAC9B,gDAAgD;AACjD;;AAEA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,YAAY;CACZ,mCAAmC;EAClC,gBAAgB;EAChB,gBAAgB;CACjB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,+BAA+B;CAC/B,gDAAgD;AACjD;;AAEA;;CAEC,mCAAmC;AACpC;;AAEA;CACC,gBAAgB;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,yCAAyC;EACzC,sDAAsD;EACtD,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,+CAA+C;EAC/C,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,qCAAqC;AACvC","sourcesContent":["/*\n * Where vars like --palette-fonts-sansSerifStack are used here, they come from\n * ckEditorStlyes.ts and are named in a convention symmetric with the structure\n * of the `theme` object.\n */\n\n.ck.ck-poll-form {\n\tborder-radius: 6px;\n\tborder: 0.5px solid #E1E1E1;\n\tbackground: var(--palette-panelBackground-default);\n\tbox-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.10);\n\tpadding: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n}\n\n.ck-reset_all .ck-poll-form-row {\n\tdisplay: flex;\n\tgap: 12px;\n}\n\n.ck-reset_all .ck-poll-form-group {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4px;\n}\n\n.ck-reset_all .ck-poll-form-label {\n\ttext-transform: uppercase;\n\tfont-size: 11px;\n\tfont-weight: 700;\n\tcolor: var(--palette-grey-600);\n\tfont-family: var(--palette-fonts-sansSerifStack);\n}\n\n.ck-reset_all .ck-poll-form-input {\n\tbackground: var(--palette-grey-600);\n\tborder-radius: 4px;\n\topacity: 0.8;\n\tbackground: var(--palette-grey-200);\n  min-width: 225px;\n  max-width: 490px;\n\twidth: 100%;\n\tpadding: 8px;\n\tfont-size: 13px;\n\tfont-weight: 500;\n\tcolor: var(--palette-grey-1000);\n\tfont-family: var(--palette-fonts-sansSerifStack);\n}\n\n.ck.ck-reset_all .ck.ck-poll-form .ck-poll-form-input:hover,\n.ck.ck-reset_all .ck.ck-poll-form .ck-poll-form-input:focus {\n\tbackground: var(--palette-grey-300);\n}\n\n.ck.ck.ck.ck.ck.ck-poll-balloon {\n\tbox-shadow: none;\n  background: none; \n  border: none;\n}\n\n.ck-poll-balloon:before {\n\tdisplay: none;\n}\n\n.ck-poll-balloon:after {\n\tdisplay: none;\n}\n\n.ck-reset_all .ck-poll-form-label-bold {\n  margin-bottom: 4px;\n  font-weight: bold;\n}\n\n.ck-reset_all .ck-poll-color-selector-container {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  gap: 8px;\n}\n\n.ck-reset_all .ck-poll-duration-group {\n  margin-left: 20px;\n}\n\n.ck-reset_all .ck-poll-duration-input-container {\n  display: flex;\n  align-items: center;\n}\n\n.ck-reset_all .ck-poll-duration-label-unit {\n  margin: 0 16px 0 6px;\n  font-weight: 500;\n  color: var(--palette-grey-1000);\n}\n\n.ck-reset_all .ck-poll-duration-label-unit:last-of-type {\n  margin-left: 6px;\n  margin-right: 0;\n}\n\n.ck-reset_all .ck-color-selector-button {\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n.ck-reset_all .ck-color-selector-button.ck-on {\n  border: 2px solid lightblue;\n}\n\n.ck-reset_all .ck-duration-input {\n  width: 50px;\n  min-width: 50px;\n  padding: 4px 8px;\n}\n\n.ck-poll {\n  font-family: var(--palette-fonts-sansSerifStack);\n  text-align: center;\n  background: var(--forum-event-background);\n  border-radius: calc(var(--borderRadius-default) * 1px);\n  margin: 10px 0;\n  padding: 20px;\n}\n.ck-poll-question {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: var(--forum-event-banner-text);\n}\n.ck-poll-slider {\n  position: relative;\n  height: 2px;\n  background: var(--forum-event-foreground);\n  margin: 40px 40px 0px 40px;\n}\n.ck-poll-circle {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: black;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border: 2px solid var(--forum-event-foreground);\n  opacity: 0.3;\n}\n.ck-poll-labels {\n  display: flex;\n  justify-content: space-between;\n  color: var(--forum-event-banner-text);\n  margin: 10px 40px;\n}\n.ck-poll-label {\n  font-weight: 500;\n  color: var(--forum-event-banner-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
